import { render, staticRenderFns } from "./UiSelect.vue?vue&type=template&id=0cbc1f30&"
import script from "./UiSelect.vue?vue&type=script&lang=js&"
export * from "./UiSelect.vue?vue&type=script&lang=js&"
import style0 from "./UiSelect.vue?vue&type=style&index=0&id=0cbc1f30&prod&module=true&lang=scss&"




function injectStyles (context) {
  
  this["$style"] = (style0.locals || style0)

}

/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  null,
  null
  
)

export default component.exports